import { Component, OnInit } from "@angular/core";

import { BaseControlComponent } from "../../../../../../form-controls/components/base-control/base-control.component";
import { ContextInteractionService } from "../../../../../../form-controls/services/context-interaction.service";


@Component({
    selector: "app-radio-data-config",
    templateUrl: "./radio-data-config.component.html",
    styleUrls: ["./radio-data-config.component.scss"],
    standalone: false
})
export class RadioDataConfigComponent extends BaseControlComponent {

  constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

  static componentName = "RadioDataConfigComponent";



  addBlankChoiceRow(): void {
    this.componentData.config.choices.push("");
  }

  removeChoice(index: number): void {
    this.componentData.config.choices.splice(index, 1);
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }
}
